/**
 * Wait until a selector's element exists, is on-screen and has held the same
 * box for two animation frames — the tour's per-step settle after the nav
 * choreography (drawer open/close, group expand) commits. With the
 * transitions suppressed by body.onboarding-tour-active this resolves within
 * a frame or two; the timeout is the backstop. Resolves true when settled,
 * false when the element never appeared / never became visible.
 */
export function waitForTargetSettled(selector, timeoutMs = 1500) {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
      resolve(!selector || !!(typeof document !== 'undefined' && document.querySelector(selector)));
      return;
    }
    const start = Date.now();
    let stableFrames = 0;
    let lastRect = null;
    const tick = () => {
      if (!selector) {
        stableFrames += 1;
        if (stableFrames >= 2) return resolve(true);
        return window.requestAnimationFrame(tick);
      }
      const el = document.querySelector(selector);
      if (!el) {
        if (Date.now() - start > timeoutMs) return resolve(false);
        return window.requestAnimationFrame(tick);
      }
      const r = el.getBoundingClientRect();
      const visible = r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth;
      const same = !!lastRect
        && Math.abs(lastRect.left - r.left) < 0.5 && Math.abs(lastRect.top - r.top) < 0.5
        && Math.abs(lastRect.width - r.width) < 0.5 && Math.abs(lastRect.height - r.height) < 0.5;
      lastRect = r;
      stableFrames = visible && same ? stableFrames + 1 : 0;
      if (stableFrames >= 2) return resolve(true);
      if (Date.now() - start > timeoutMs) return resolve(visible);
      return window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  });
}
